/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const { blankHostileDomain } = require("./src/utils/hostile-domain-guard")

blankHostileDomain()

export { wrapRootElement } from "./src/apollo/wrap-root-element"
